import axiosInstance from "../Axios";
export async function GetStudentDetails(LIDs) {
    try {
        const res = await axiosInstance.get(`/NCLAdmin/GetStudentDetailsbyLoginIds`, { params: { LoginId: LIDs }, })
        return res.data
    }
    catch (err) { console.log(err) }
}

export async function UpdateBulkStudentStatus(IDDetails) {
    try {
        const res = await axiosInstance .post(`/NCLAdmin/UpdateBulkStudentStatus`,IDDetails )
        return res.data
    }
    catch (err) { console.log(err); return "" }
}